import { isEmpty } from 'modules/object_utils';

export class AnalysisAccordion {
  constructor(root, { formTemplateHtml, dataSets, helper, onPanelActivated }) {
    this.root = root;
    this.formTemplateHtml = formTemplateHtml;
    this.dataSets = dataSets;
    this.helper = helper;
    this.onPanelActivated = onPanelActivated;
    this.pairs = [];
    this.activeIndex = 0;

    this.collectPairs();
    this.bindHeaders();
    this.activate(0, { initial: true });
  }

  collectPairs() {
    const children = [...this.root.children];
    for (let i = 0; i < children.length; i += 2) {
      const header = children[i];
      const panel = children[i + 1];
      if (!header || !panel) continue;

      header.classList.add('ui-accordion-header');
      panel.classList.add('ui-accordion-content');

      if (!header.id) header.id = `ui-accordion-accordion-header-${this.pairs.length + 1}`;
      if (!panel.id) panel.id = header.id.replace('header', 'panel');

      this.pairs.push({ header, panel });
    }
  }

  bindHeaders() {
    this.pairs.forEach((pair, index) => {
      pair.header.addEventListener('click', (event) => {
        if (event.target.closest('.ui-icon-help, [data-target-step]')) {
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        this.activate(index);
      });
    });
  }

  activate(index, { initial = false } = {}) {
    const pair = this.pairs[index];
    if (!pair) return;

    const headerId = pair.header.id;
    const isChartSettings = headerId === 'chart_settings';

    if (!initial && !isChartSettings) {
      const form = document.getElementById('dataSetForm');
      if (form) {
        const serializedForm = {};
        new FormData(form).forEach((value, key) => {
          serializedForm[key] = value;
        });

        pair.panel.innerHTML = this.formTemplateHtml;

        form.reset();

        const formValues = this.dataSets[this.helper.parse_dataset_id(headerId)] || false;
        if (formValues) {
          Object.entries(formValues).forEach(([name, value]) => {
            if (name === 'date_type') {
              document.querySelectorAll('#datetype :radio').forEach((radio) => {
                radio.checked = false;
              });
              const radio = document.getElementById(`${name}_${value}`);
              if (radio) radio.checked = true;
            } else {
              const field = document.getElementById(name) || document.querySelector(`[name="${name}"]`);
              if (field) field.value = value;
            }
          });
        }
      }
    }

    this.pairs.forEach((item, itemIndex) => {
      const active = itemIndex === index;
      item.panel.hidden = !active;
      item.panel.style.display = active ? '' : 'none';
      item.header.classList.toggle('ui-state-active', active);
    });

    this.activeIndex = index;

    if (!isChartSettings) {
      const dsId = this.helper.parse_dataset_id(headerId);
      if (dsId > 0) {
        this.dataSets[dsId] = {};
        const form = document.getElementById('dataSetForm');
        if (form) {
          new FormData(form).forEach((value, key) => {
            this.dataSets[dsId][key] = value;
          });
        }

        document.querySelectorAll('.removePanel').forEach((node) => node.remove());

        if (!isEmpty(this.dataSets[dsId].company_name)) {
          const display = document.getElementById('companyNameDisplay');
          if (display) display.innerHTML = this.dataSets[dsId].company_name;
        }
      }
    }

    document.querySelectorAll('#chart_title, #project_name, #dataset_name').forEach((input) => {
      input.setAttribute('autocomplete', 'off');
    });

    this.onPanelActivated?.(pair);
  }

  addPanel(tabCount) {
    const header = document.createElement('h5');
    header.id = `ui-accordion-accordion-header-${tabCount}`;
    header.className = 'ui-accordion-header';
    header.innerHTML = `<a href="#">Data set ${tabCount}</a><span class="ui-icon ui-icon-help" data-target-step="2"></span>`;

    const panel = document.createElement('div');
    panel.id = `ui-accordion-accordion-panel-${tabCount}`;
    panel.className = 'ui-accordion-content';

    this.root.appendChild(header);
    this.root.appendChild(panel);

    this.pairs.push({ header, panel });
    header.addEventListener('click', (event) => {
      if (event.target.closest('.ui-icon-help, [data-target-step]')) {
        event.stopPropagation();
        return;
      }
      event.preventDefault();
      this.activate(this.pairs.length - 1);
    });

    this.activate(this.pairs.length - 1);
  }

  markPanelForRemoval(panelId) {
    const headerId = panelId.replace('panel', 'header');
    const headerIndex = this.pairs.findIndex((pair) => pair.panel.id === panelId);
    if (headerIndex > 0) {
      this.activate(headerIndex - 1);
      document.getElementById(headerId)?.classList.add('removePanel');
      document.getElementById(panelId)?.classList.add('removePanel');
      delete this.dataSets[this.helper.parse_dataset_id(panelId)];
      delete this.helper.data[this.helper.parse_dataset_id(panelId)];
    }
  }
}
